import _extends from '@babel/runtime-corejs3/helpers/extends';
import React__default from 'react';
import classNames from 'classnames';
import styles from './Label2.js';
import { useFormFieldLabel } from '../FormField/FormFieldContext.js';

const Label = /*#__PURE__*/React__default.forwardRef((_ref, ref) => {
  let {
    children,
    className,
    ...rest
  } = _ref;
  const {
    isFocused,
    hasControl
  } = useFormFieldLabel();
  const classes = classNames(styles.label, className, {
    [styles.control]: hasControl,
    [styles.focused]: isFocused
  });
  return /*#__PURE__*/React__default.createElement("label", _extends({}, rest, {
    ref: ref,
    className: classes
  }), children);
});

export { Label as default };
